module.exports = __webpack_public_path__ + "media/images/orion_pictos/orion-svg-sprite-0dbc766a3ecd912f4e2d436d99c8e68a.svg";